<template>
  <div class="blue-box--container">
    <div class="blue-box">
      <a :href="offer.ctaLink" target="_blank" class="blue-box-content">
        <img :src="blueBoxImage" :title="offer.offerName" alt="Home Insurance Offer" />
      </a>
      <a :href="offer.infoLink" target="_blank" class="icon-container">
        <v-icon class="info-icon">info</v-icon>
      </a>
    </div>
  </div>
</template>

<script>
import blueBoxImage from '@/assets/blueBox.png';

export default {
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      blueBoxImage,
    };
  },
};
</script>


<style lang='scss' scoped>
$icon-size: 22px;
$icon-border-size: 2px;
$icon-border-color: #727272;

.blue-box--container {
  text-align: center;
}

.blue-box {
  background: #1B449C;
  display: inline-block;
  height: 300px;
  position: relative;
  text-align: center;

  img {
    height: 300px;
    max-width: 350px;
    width: auto;
  }

  &-content {
    display: block;
    position: relative;
    z-index: 1;
  }
}

.icon-container {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 2;

  .v-icon.info-icon {
    background-color: $icon-border-color;
    border: $icon-border-size $icon-border-color solid;
    border-radius: $icon-size;
    color: #fefefe;
    height: $icon-size;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
    width: $icon-size;
  }
}
</style>
